
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article_drafts/[id]/publication",
      function () {
        return require("private-next-pages/article_drafts/[id]/publication.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article_drafts/[id]/publication"])
      });
    }
  